import { render } from "./InputHeader.vue?vue&type=template&id=5211eb37&scoped=true"
import script from "./InputHeader.vue?vue&type=script&lang=js"
export * from "./InputHeader.vue?vue&type=script&lang=js"

import "./InputHeader.vue?vue&type=style&index=0&id=5211eb37&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5211eb37"]])

export default __exports__